
  (function (){
    var globalThis = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {});
    globalThis._WSMP = globalThis._WSMP || {};
    globalThis._WSMP.version = "1.0.7/static";
    globalThis._WSMP.project = "informat-frontend";
    })();